/**
 * POSの売り上げ区分
 *  0:売上
    1:返品
    2:承り
    3:承りキャンセル
    4:お渡し
 */

export enum PosSalesType {
  SALES = 0,
  RETURN = 1,
  ACCEPT = 2,
  CANCELED = 3,
  HANDED_OVER = 4,
}
